import React from "react"
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  Cell,
} from "recharts"

const data = [
  { name: "Local Dispatch",       value: 5700, label: "5.7k" },
  { name: "Interstate Delivery",  value: 4500, label: "2k"   },
  { name: "Express Delivery",     value: 3500, label: "1.5k" },
  { name: "Bulk Package Return",  value: 2500, label: "1k"   },
  { name: "Scheduled Pickup",     value: 1500, label: "850"  },
  { name: "Last-Mile Delivery",   value:  970, label: "120"  },
]

const COLORS = ["#3B5BFF", "#4E6CFF", "#6782FF", "#81A0FF", "#A8BFFF", "#CFE0FF"]

const MostRequested: React.FC = () => {
  return (
    <div className="w-full h-[375px] pb-4">
      <ResponsiveContainer>
        <ComposedChart
          layout="vertical"
          data={data}
          margin={{ top: 10, right: 40, bottom: 10, left: 10 }}
        >
          <CartesianGrid horizontal={false} vertical={false} />
          <XAxis type="number" hide />
          
          <YAxis type="category" dataKey="name" hide />

          <Tooltip formatter={(v: number) => v.toLocaleString()} />

          <Bar dataKey="value" barSize={32} >
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
            <LabelList
              dataKey="name"
              position="insideLeft"
              style={{ fill: "#fff", fontSize: 12, fontWeight: 500 }}
              offset={10}
            />
            <LabelList
              dataKey="label"
              position="right"
              offset={8}
              style={{ fill: "#111827", fontSize: 12 }}
            />
          </Bar>
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  )
}

export default MostRequested;
